import { Injectable, inject } from '@angular/core';
import {environment} from '@environments/environment';
import {HttpClient, HttpEventType, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';

/** Progress tick (`url` null) or terminal result (`progress` 100) from uploadFileWithProgress. */
export interface SbUploadEvent {
  progress: number;
  url: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class AwsService {
  private http = inject(HttpClient);

  private baseApiUrl = environment.apiUrl;
  private fileUrl = this.baseApiUrl + '/api/v1/file';

  uploadFile(file, projectId: any = null, clientId: any = null, token: string | null = null) {
    // return new Promise((resolve, reject) => {
    //   this.signedURL(file).subscribe((signed) => {
    //     resolve(signed);
    //     // const headers = new HttpHeaders({'Content-Type': file.type, 'Skip-auth': 'true'});
    //     // const options = {headers, reportProgress: true};
    //     // this.http.put(signed['url'], file, options).subscribe(() => resolve(signed), (err) => reject(err));
    //   }, (err) => reject(err));
    // });

    //
    // Get file url
    let fileUrl: string = this.fileUrl;
    // Extend url with token if available
    if (token !== null) {
      fileUrl += `/token/${token}`;
    }

    const formData = new FormData();
    formData.append('file', file);
    if (projectId) {
      formData.append('projectId', projectId);
    }
    if (clientId) {
      formData.append('clientId', clientId);
    }
    // No explicit Content-Type: the browser sets multipart/form-data with its boundary, and a
    // hand-set header without the boundary is what makes busboy reject the upload.
    return this.http.post(`${fileUrl}`, formData);
  }

  /**
   * Same endpoint as `uploadFile`, but reports upload progress and unwraps the response to the
   * stored URL. Kept separate because `uploadFile`'s callers rely on its plain-response shape.
   *
   * The Content-Type header is deliberately not set: the browser has to add the multipart boundary
   * itself, and setting it by hand strips it.
   */
  uploadFileWithProgress(file, projectId: any = null, clientId: any = null): Observable<SbUploadEvent> {
    const formData = new FormData();
    formData.append('file', file);
    if (projectId) {
      formData.append('projectId', projectId);
    }
    if (clientId) {
      formData.append('clientId', clientId);
    }

    return new Observable<SbUploadEvent>((observer) => {
      const sub = this.http.post(this.fileUrl, formData, {reportProgress: true, observe: 'events'})
        .subscribe({
          next: (event: any) => {
            if (event.type === HttpEventType.UploadProgress) {
              const total = event.total || 0;
              observer.next({progress: total ? Math.round(100 * event.loaded / total) : 0, url: null});
              return;
            }
            if (event.type === HttpEventType.Response) {
              const url = event.body?.data?.url || null;
              if (!url) {
                observer.error(new Error('Upload did not return a file URL'));
                return;
              }
              observer.next({progress: 100, url});
              observer.complete();
            }
          },
          error: (err) => observer.error(err),
        });
      return () => sub.unsubscribe();
    });
  }

  getAwsSignedUrl(fileName, contentType, tag = null) {
    const fileUrl = `${this.fileUrl}/get-signed-url`;
    return this.http.get(`${fileUrl}`, {params: {fileName, contentType, tag}});
  }

  uploadFileToSignedUrl(url, fileData) {
    return this.http.put(url, fileData, {
      headers: new HttpHeaders().set('Skip-auth', 'true').set('Content-Type', fileData.type),
      reportProgress: true, observe: 'events'
    });
  }
}
